import MainLayout from '../../components/layouts/mainLayout';

const TermsAndConditions = () => {
    return (
        <MainLayout>
            <div className="max-w-4xl mx-auto p-6 bg-white shadow-lg rounded-lg mt-5 text-start mb-5">
                <h1 className="text-3xl font-bold text-primary mb-6">Terms & Conditions</h1>
                <p className="text-secondary mb-4">
                    Welcome to Invetix POS. By using our services, you agree to abide by these Terms & Conditions. Please read them carefully before proceeding.
                </p>
                <p className="text-secondary mb-4">
                    Last Updated: 01/01/2025
                </p>

                <h2 className="text-xl font-semibold mt-6">1. Acceptance of Terms</h2>
                <p className="text-secondary">
                    By accessing or using Invetix POS, you agree to be bound by these terms. If you do not agree with any part of these terms, you may not use our services.
                </p>

                <h2 className="text-xl font-semibold mt-6">2. Services Provided</h2>
                <p className="text-secondary">
                    Invetix POS is a point-of-sale (POS) and billing system designed to help businesses manage transactions, invoices, reports, and analytics efficiently.
                </p>

                <h2 className="text-xl font-semibold mt-6">3. User Accounts</h2>
                <p className="text-secondary">
                    You must provide accurate and complete registration information. You are responsible for maintaining the confidentiality of your account credentials. We reserve the right to suspend or terminate accounts that violate our policies.
                </p>

                <h2 className="text-xl font-semibold mt-6">4. Free Trial & Subscription</h2>
                <p className="text-secondary">
                    We offer a 5-day free trial with full access to all features. After the trial, users must subscribe to a paid plan to continue using the service. Subscription fees are non-refundable once paid.
                </p>

                <h2 className="text-xl font-semibold mt-6">5. Payment & Billing</h2>
                <p className="text-secondary">
                    Payments are processed securely through third-party payment gateways such as Stripe and Razorpay. You agree to provide accurate billing information and authorize us to charge your payment method for recurring fees. Failure to make timely payments may result in suspension or termination of your account.
                </p>

                <h2 className="text-xl font-semibold mt-6">6. Invoice Generation & Printing</h2>
                <p className="text-secondary">
                    Users can generate and print invoices using Invetix POS. Invoice customization options are available to meet business needs. Invoices are stored for future reference and compliance.
                </p>

                <h2 className="text-xl font-semibold mt-6">7. Data Security & Privacy</h2>
                <p className="text-secondary">
                    We take reasonable measures to protect user data. Our Privacy Policy outlines how we collect, use, and store your data. Users are responsible for safeguarding their account credentials.
                </p>

                <h2 className="text-xl font-semibold mt-6">8. Usage Restrictions</h2>
                <p className="text-secondary">
                    You agree not to:
                    <ul className="list-disc pl-6">
                        <li>Use Invetix POS for any unlawful or fraudulent activity.</li>
                        <li>Attempt to modify, decompile, or reverse-engineer the software.</li>
                        <li>Share access credentials with unauthorized users.</li>
                    </ul>
                </p>

                <h2 className="text-xl font-semibold mt-6">9. Service Availability</h2>
                <p className="text-secondary">
                    We strive to provide 24/7 access to our services but do not guarantee uninterrupted availability. Scheduled maintenance and unforeseen issues may cause temporary downtime.
                </p>

                <h2 className="text-xl font-semibold mt-6">10. Termination of Service</h2>
                <p className="text-secondary">
                    We reserve the right to suspend or terminate accounts that violate our policies or engage in fraudulent activities. Users may cancel their subscription at any time, but no refunds will be issued for unused periods.
                </p>

                <h2 className="text-xl font-semibold mt-6">11. Limitation of Liability</h2>
                <p className="text-secondary">
                    Invetix POS is provided "as is" without warranties of any kind. We are not liable for any losses, damages, or disruptions resulting from your use of the service.
                </p>

                <h2 className="text-xl font-semibold mt-6">12. Modifications to Terms</h2>
                <p className="text-secondary">
                    We may update these terms from time to time. Continued use of our services after updates constitutes acceptance of the revised terms.
                </p>

                <h2 className="text-xl font-semibold mt-6">13. Contact Information</h2>
                <p className="text-secondary">
                    For any questions or concerns regarding these Terms & Conditions, please contact us at support@invetix.com.
                </p>
            </div>
        </MainLayout>
    );
};

export default TermsAndConditions;
